
import { defineComponent, ref, onMounted } from "vue";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import type { ElForm } from "element-plus";

type FormInstance = InstanceType<typeof ElForm>;

export default defineComponent({
  setup() {
    onMounted(() => {
      if (!route.params.id) {
        setCurrentPageBreadcrumbs("分销新增", ["分销管理", "分销列表"]);
      } else {
        setCurrentPageBreadcrumbs("分销编辑", ["分销管理", "分销列表"]);
      }
    });

    const formRef = ref<FormInstance>();
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const distribution = ref({
      mobile: "",
      enabled: false,
    });

    const isNew = !route.params.id;

    const rules = ref({});

    rules.value = {
      mobile: [
        {
          required: true,
          message: "分销手机号码不可为空",
          trigger: "change",
        },
      ],
    };

    const onCancel = () => {
      router.push({ name: "distributions" });
    };

    const onSubmit = (formEl: FormInstance | undefined) => {
      if (!formEl) return;

      formEl.validate((valid) => {
        if (valid) {
          if (isNew) {
            store
              .dispatch(Actions.CREATE_DISTRIBUTION, distribution.value)
              .then(() => {
                if (store.getters.getErrors) {
                  Swal.fire({
                    text: store.getters.getErrors,
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonText: "确认",
                    customClass: {
                      confirmButton: "btn fw-bold btn-light-danger",
                    },
                  })
                } else {
                  router.push({ name: "distributions" });
                }

                // router.push({ name: "distributions" });

                // Swal.fire({
                //   text: store.getters.getErrors,
                //   icon: "error",
                //   buttonsStyling: false,
                //   confirmButtonText: "确认",
                //   customClass: {
                //     confirmButton: "btn fw-bold btn-light-danger",
                //   },
                // })
              })
              .catch(() => {
                // const [error] = Object.keys(store.getters.getErrors);
                // Swal.fire({
                //   text: store.getters.getErrors[error],
                //   icon: "error",
                //   buttonsStyling: false,
                //   confirmButtonText: "Try again!",
                //   customClass: {
                //     confirmButton: "btn fw-bold btn-light-danger",
                //   },
                // });
              });
          } else {
            console.log(distribution.value)

            store
              .dispatch(Actions.UPDATE_DISTRIBUTION, {
                id: route.params.id,
                values: distribution.value,
              })
              .then(() => {
                if (store.getters.getErrors) {
                  Swal.fire({
                    text: store.getters.getErrors,
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonText: "确认",
                    customClass: {
                      confirmButton: "btn fw-bold btn-light-danger",
                    },
                  })
                } else {
                  router.push({ name: "distributions" });
                }
              })
              .catch(() => {
                // const [error] = Object.keys(store.getters.getErrors);
                // Swal.fire({
                //   text: store.getters.getErrors[error],
                //   icon: "error",
                //   buttonsStyling: false,
                //   confirmButtonText: "Try again!",
                //   customClass: {
                //     confirmButton: "btn fw-bold btn-light-danger",
                //   },
                // });
              });
          }
        } else {
          return false;
        }
      });
    };

    if (!isNew) {
      store
        .dispatch(Actions.GET_DISTRIBUTION, route.params.id)
        .then(() => {
          distribution.value = store.getters.currentDistribution;
        })
        .catch(() => {
          // const [error] = Object.keys(store.getters.getErrors);
          // Swal.fire({
          //   text: store.getters.getErrors[error],
          //   icon: "error",
          //   buttonsStyling: false,
          //   confirmButtonText: "Try again!",
          //   customClass: {
          //     confirmButton: "btn fw-bold btn-light-danger",
          //   },
          // });
        });
    }

    return {
      onSubmit,
      distribution,
      rules,
      onCancel,
      formRef,
    };
  },
});
